/**
 * Leagues shown in the top Leagues view — order matches the home feed (excludes World row).
 * imageKey builds URL: /images/league_${imageKey}.png
 */
export const LEAGUES_NAV = [
    { id: 'wsl', label: 'WSL', title: "Women's Super League", imageKey: 'wsl' },
    { id: 'nwsl', label: 'NWSL', title: 'National Women\'s Soccer League', imageKey: 'nwsl' },
    { id: 'we', label: 'WE', title: 'WE League', imageKey: 'we' },
    { id: 'usl', label: 'USL', title: 'USL Super League', imageKey: 'usl' },
    { id: 'seriea', label: 'SERIE A', title: 'Serie A Femminile', imageKey: 'seriea' },
    { id: 'dfb', label: 'DFB', title: 'Frauen-Bundesliga', imageKey: 'dfb' },
    { id: 'wk', label: 'WK', title: 'WK League', imageKey: 'wk' },
    { id: 'bpi', label: 'LIGA BPI', title: 'Campeonato Nacional Feminino', imageKey: 'bpi' },
    { id: 'ligamx', label: 'LIGA MX', title: 'Liga MX Femenil', imageKey: 'ligamx' },
    { id: 'nwfl', label: 'NWFL', title: 'NWFL Premiership', imageKey: 'nwfl' },
    { id: 'ligaf', label: 'LIGA F', title: 'Liga F', imageKey: 'ligaf' },
    { id: 'sweden', label: 'OBOS', title: 'Obos Damallsvenskan', imageKey: 'obos' },
    { id: 'brasil', label: 'Brasileirão', title: 'Brasileirão Feminino', imageKey: 'bra' },
    { id: 'apl', label: 'ARKEMA PL', title: 'Arkema Première Ligue', imageKey: 'apl' },
    { id: 'aleague', label: 'A LEAGUE', title: 'A-League Women', imageKey: 'a' },
    { id: 'toppserien', label: 'TOPP', title: 'Toppserien', imageKey: 'toppserien' },
    { id: 'eredivisie', label: 'ERE W', title: 'Eredivisie Vrouwen', imageKey: 'eredivisie' },
    { id: 'ofb', label: 'ÖFB', title: 'ÖFB Frauen-Bundesliga', imageKey: 'ofb' },
    { id: "bwsl", label: "BWSL", title: "Belgian Women's Super League", imageKey: "bwsl" },
    { id: 'nsl', label: 'NSL', title: 'Northern Super League', imageKey: 'nsl' },
    { id: 'saff', label: 'SAFF', title: 'Saudi Women\'s Premier League', imageKey: 'saff' }
];

export const DEFAULT_LEAGUE_ID = 'wsl';

export function getLeagueById(id) {
    return LEAGUES_NAV.find((l) => l.id === id) || LEAGUES_NAV[0];
}

/** Sub-navigation tabs inside a league view */
export const LEAGUE_TABS = [
    { id: 'matches', label: 'Matches', icon: '⌾' },
    { id: 'table', label: 'Table', icon: '▦' },
    { id: 'clubs', label: 'Clubs', icon: '⌂' },
    { id: 'media', label: 'Media', icon: '▣' },
    { id: 'stats', label: 'Stats', icon: '▤' },
    { id: 'about', label: 'About', icon: 'ⓘ' },
    { id: 'classic', label: 'Classic', icon: '{ }' }
];
